import { httpClient } from "@api/httpClient";

export async function exportSalesforceRoles() {
  try {
    await httpClient
      .get(`/api/v1/salesforce/roles/export`, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        var currDate = new Date().toLocaleString().replace(",", "");
        link.setAttribute(
          "download",
          "GEARSSALESFORCEROLES_" + currDate + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  } catch (error) {
    throw error;
  }
}
